import {define} from './define'
import type {GroupReturn} from '../types'

export const content = (): GroupReturn => define('content', {default: true})
